import React, { useState, useEffect } from 'react';

interface HomeScreenProps {
    onGoToLogin: () => void;
    onGoToRegister: () => void;
    onGoToHelp?: () => void;
    onGoToPrivacySecurity?: () => void;
    onGoToSecurityPolicy?: () => void;
    onGoToCommunityGuidelines?: () => void;
    onGoToTermsOfService?: () => void;
    onGoToAbout?: () => void;
}

const HomeScreen: React.FC<HomeScreenProps> = ({
    onGoToLogin,
    onGoToRegister,
    onGoToHelp,
    onGoToPrivacySecurity,
    onGoToSecurityPolicy,
    onGoToCommunityGuidelines,
    onGoToTermsOfService,
    onGoToAbout,
}) => {
    const [isMobile, setIsMobile] = useState(false);
    const [news, setNews] = useState<any[]>([]);
    const [blogPosts, setBlogPosts] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const loadContent = async () => {
            try {
                setLoading(true);
                const API_URL = 'https://voicechatapi.kasaneko.com';

                const [newsResponse, blogResponse] = await Promise.all([
                    fetch(`${API_URL}/api/content/news?limit=10`),
                    fetch(`${API_URL}/api/content/blog?limit=10`),
                ]);

                const newsData = await newsResponse.json();
                const blogData = await blogResponse.json();

                if (newsData.success) {
                    setNews(newsData.news || []);
                }
                if (blogData.success) {
                    setBlogPosts(blogData.posts || []);
                }
            } catch (error) {
                console.error('コンテンツ取得エラー:', error);
            } finally {
                setLoading(false);
            }
        };

        loadContent();
    }, []);

    return (
        <div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 50%, #dcdcdc 100%)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                fontFamily: 'Arial, sans-serif',
                color: '#333',
                overflow: 'hidden',
            }}
        >
            {/* ヘッダー */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    height: '10%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                }}
            >
                {/* 左上: アプリアイコン */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: isMobile ? '3%' : '3%',
                        transform: 'translateY(-50%)',
                        fontWeight: 'bold',
                        fontSize: isMobile ? '20px' : '28px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    🎙️ Voitter
                </div>

                {/* 右上: ログイン・新規登録ボタン */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: isMobile ? '3%' : '3%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        gap: isMobile ? '8px' : '12px',
                        alignItems: 'center',
                    }}
                >
                    <button
                        onClick={onGoToLogin}
                        style={{
                            background: '#5f27cd',
                            color: 'white',
                            border: 'none',
                            borderRadius: isMobile ? '8px' : '10px',
                            cursor: 'pointer',
                            fontSize: isMobile ? '13px' : '15px',
                            fontWeight: 'bold',
                            padding: isMobile ? '8px 16px' : '10px 20px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        ログイン
                    </button>
                    <button
                        onClick={onGoToRegister}
                        style={{
                            background: '#00d4aa',
                            color: 'white',
                            border: 'none',
                            borderRadius: isMobile ? '8px' : '10px',
                            cursor: 'pointer',
                            fontSize: isMobile ? '13px' : '15px',
                            fontWeight: 'bold',
                            padding: isMobile ? '8px 16px' : '10px 20px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        新規登録
                    </button>
                </div>
            </div>

            {/* メインコンテンツ（スクロール可能） */}
            <div
                style={{
                    position: 'absolute',
                    top: '10%',
                    width: '100%',
                    height: '90%',
                    overflow: 'auto',
                    overflowX: 'hidden',
                }}
            >
                {/* コンテンツラッパー（スクロール可能な領域） */}
                <div
                    style={{
                        width: '100%',
                        paddingBottom: isMobile ? 'calc(env(safe-area-inset-bottom, 0px) + 20px)' : '20px',
                    }}
                >
                    {/* スマホ: 楽しくお話ししよう！要素 */}
                    {isMobile && (
                        <div
                            style={{
                                width: '100%',
                                padding: '40px 20px',
                                marginBottom: '20px',
                                textAlign: 'center',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '28px',
                                    fontWeight: 'bold',
                                    color: '#333',
                                    textShadow: 'none',
                                    lineHeight: '1.6',
                                }}
                            >
                                楽しくお話ししよう！✨
                            </div>
                        </div>
                    )}

                    {/* ブログおよびニュース */}
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            marginBottom: '20px',
                            gap: isMobile ? '15px' : '15px',
                            alignItems: isMobile ? 'stretch' : 'flex-start',
                        }}
                    >
                        {/* お知らせ */}
                        <div
                            style={{
                                width: isMobile ? 'calc(100% - 30px)' : '30%',
                                marginLeft: isMobile ? '15px' : '0',
                                marginRight: isMobile ? '15px' : '0',
                                height: isMobile ? '250px' : '450px',
                                background: 'rgba(255, 255, 255, 0.9)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '0',
                                boxSizing: 'border-box',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: isMobile ? '16px' : '18px',
                                    fontWeight: 'bold',
                                    borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
                                    padding: '20px 20px 10px 20px',
                                    marginBottom: '0',
                                    position: 'sticky',
                                    top: 0,
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    zIndex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                }}
                            >
                                <a
                                    href='https://voicechatinfo.kasaneko.com/#news'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                        textDecoration: 'none',
                                        color: '#333',
                                        fontSize: isMobile ? '20px' : '22px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                    title='お知らせページを開く'
                                >
                                    🔗
                                </a>
                                📢 お知らせ
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    flex: 1,
                                    overflow: 'auto',
                                    padding: '15px 20px 20px 20px',
                                }}
                            >
                                {loading ? (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            color: '#666',
                                            fontSize: isMobile ? '12px' : '14px',
                                        }}
                                    >
                                        読み込み中...
                                    </div>
                                ) : news.length === 0 ? (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            color: '#666',
                                            fontSize: isMobile ? '12px' : '14px',
                                        }}
                                    >
                                        お知らせはありません
                                    </div>
                                ) : (
                                    news.map((item, index) => (
                                        <div
                                            key={item.newsId || index}
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.9)',
                                                border: '1px solid rgba(0, 0, 0, 0.15)',
                                                borderRadius: '12px',
                                                marginBottom: '10px',
                                                fontSize: isMobile ? '11px' : '13px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '10px' : '12px',
                                                    color: '#666',
                                                }}
                                            >
                                                {item.createdAt
                                                    ? new Date(item.createdAt).toLocaleDateString(
                                                          'ja-JP',
                                                          {
                                                              year: 'numeric',
                                                              month: 'long',
                                                              day: 'numeric',
                                                          }
                                                      )
                                                    : ''}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '12px' : '14px',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {item.title}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '11px' : '13px',
                                                    lineHeight: '1.6',
                                                    color: '#333',
                                                    whiteSpace: 'pre-wrap',
                                                }}
                                            >
                                                {item.content}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* PC: 楽しくお話ししよう！要素 */}
                        {!isMobile && (
                            <div
                                style={{
                                    width: '40%',
                                    height: '450px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '20px',
                                    alignSelf: 'flex-start',
                                    overflow: 'auto',
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        padding: '70px 20px',
                                        textAlign: 'center',
                                        background: 'rgba(255, 255, 255, 0.9)',
                                        backdropFilter: 'blur(10px)',
                                        borderRadius: '12px',
                                        border: '1px solid rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '32px',
                                            fontWeight: 'bold',
                                            color: '#333',
                                            textShadow: 'none',
                                            lineHeight: '1.6',
                                        }}
                                    >
                                        楽しくお話ししよう！✨
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* 運営ブログ */}
                        <div
                            style={{
                                width: isMobile ? 'calc(100% - 30px)' : '30%',
                                marginLeft: isMobile ? '15px' : '0',
                                marginRight: isMobile ? '15px' : '0',
                                height: isMobile ? '250px' : '450px',
                                background: 'rgba(255, 255, 255, 0.9)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(0, 0, 0, 0.1)',
                                display: 'flex',
                                flexDirection: 'column',
                                padding: '0',
                                boxSizing: 'border-box',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: isMobile ? '16px' : '18px',
                                    fontWeight: 'bold',
                                    borderBottom: '2px solid rgba(0, 0, 0, 0.2)',
                                    padding: '20px 20px 10px 20px',
                                    marginBottom: '0',
                                    position: 'sticky',
                                    top: 0,
                                    background: 'rgba(255, 255, 255, 0.9)',
                                    backdropFilter: 'blur(10px)',
                                    zIndex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                }}
                            >
                                <a
                                    href='https://voicechatinfo.kasaneko.com/#blog'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                        textDecoration: 'none',
                                        color: '#333',
                                        fontSize: isMobile ? '20px' : '22px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                    title='ブログページを開く'
                                >
                                    🔗
                                </a>
                                📝 運営ブログ
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    flex: 1,
                                    overflow: 'auto',
                                    padding: '15px 20px 20px 20px',
                                }}
                            >
                                {loading ? (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            color: '#666',
                                            fontSize: isMobile ? '12px' : '14px',
                                        }}
                                    >
                                        読み込み中...
                                    </div>
                                ) : blogPosts.length === 0 ? (
                                    <div
                                        style={{
                                            textAlign: 'center',
                                            color: '#666',
                                            fontSize: isMobile ? '12px' : '14px',
                                        }}
                                    >
                                        ブログ記事はありません
                                    </div>
                                ) : (
                                    blogPosts.map((item, index) => (
                                        <div
                                            key={item.postId || index}
                                            style={{
                                                background: 'rgba(255, 255, 255, 0.9)',
                                                border: '1px solid rgba(0, 0, 0, 0.15)',
                                                borderRadius: '12px',
                                                marginBottom: '10px',
                                                fontSize: isMobile ? '11px' : '13px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '10px' : '12px',
                                                    color: '#666',
                                                }}
                                            >
                                                {item.createdAt
                                                    ? new Date(item.createdAt).toLocaleDateString(
                                                          'ja-JP',
                                                          {
                                                              year: 'numeric',
                                                              month: 'long',
                                                              day: 'numeric',
                                                          }
                                                      )
                                                    : ''}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '12px' : '14px',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                {item.title}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: isMobile ? '11px' : '13px',
                                                    lineHeight: '1.6',
                                                    color: '#333',
                                                    whiteSpace: 'pre-wrap',
                                                }}
                                            >
                                                {item.content}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>

                    {/* このアプリについての説明 */}
                    <div
                        style={{
                            width: '100%',
                            padding: isMobile ? '30px 20px' : '40px 20px',
                            marginBottom: '20px',
                            background: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            fontSize: isMobile ? '16px' : '18px',
                            lineHeight: '1.8',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div
                            style={{
                                fontSize: isMobile ? '22px' : '28px',
                                fontWeight: 'bold',
                                marginBottom: '15px',
                            }}
                        >
                            Voitterについて
                        </div>
                        <div
                            style={{
                                width: isMobile ? '90%' : '70%',
                                color: '#333',
                                fontSize: isMobile ? '15px' : '17px',
                            }}
                        >
                            Voitterは、ユーザー同士が音声通話を通じてコミュニケーションを取るためのマッチングサービスです。気軽に会話を楽しみたい方、新しい出会いを求める方、練習や勉強のための会話パートナーを探している方など、様々な用途でご利用いただけます。
                        </div>
                    </div>

                    {/* 各種リンク */}
                    <div
                        style={{
                            width: '100%',
                            padding: isMobile ? '30px 20px' : '40px 20px',
                            marginBottom: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div
                            style={{
                                fontSize: isMobile ? '18px' : '20px',
                                fontWeight: 'bold',
                                marginBottom: isMobile ? '15px' : '20px',
                            }}
                        >
                            各種リンク
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: isMobile ? '20px' : '40px',
                                width: '100%',
                                flexWrap: 'wrap',
                            }}
                        >
                            <a
                                href='https://twitter.com'
                                target='_blank'
                                rel='noopener noreferrer'
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                    color: '#333',
                                    gap: '8px',
                                }}
                            >
                                <span style={{ fontSize: isMobile ? '40px' : '48px' }}>🐦</span>
                                <span style={{ fontSize: isMobile ? '14px' : '16px' }}>Twitterはこちら</span>
                            </a>
                            <a
                                href='https://blog.example.com'
                                target='_blank'
                                rel='noopener noreferrer'
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textDecoration: 'none',
                                    color: '#333',
                                    gap: '8px',
                                }}
                            >
                                <span style={{ fontSize: isMobile ? '40px' : '48px' }}>📝</span>
                                <span style={{ fontSize: isMobile ? '14px' : '16px' }}>ブログはこちら</span>
                            </a>
                        </div>
                    </div>

                    {/* ご利用案内 */}
                    <div
                        style={{
                            width: '100%',
                            padding: isMobile ? '30px 20px' : '40px 20px',
                            marginBottom: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div
                            style={{
                                fontSize: isMobile ? '18px' : '20px',
                                fontWeight: 'bold',
                                marginBottom: isMobile ? '15px' : '20px',
                            }}
                        >
                            ご利用案内
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                flexWrap: isMobile ? 'nowrap' : 'wrap',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: isMobile ? '10px' : '15px',
                                width: '100%',
                            }}
                        >
                            {onGoToHelp && (
                                <button
                                    onClick={onGoToHelp}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    ヘルプ
                                </button>
                            )}
                            {onGoToPrivacySecurity && (
                                <button
                                    onClick={onGoToPrivacySecurity}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    プライバシーセキュリティ
                                </button>
                            )}
                            {onGoToSecurityPolicy && (
                                <button
                                    onClick={onGoToSecurityPolicy}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    情報セキュリティ基本方針
                                </button>
                            )}
                            {onGoToCommunityGuidelines && (
                                <button
                                    onClick={onGoToCommunityGuidelines}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    コミュニティガイドライン
                                </button>
                            )}
                            {onGoToTermsOfService && (
                                <button
                                    onClick={onGoToTermsOfService}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    利用規約
                                </button>
                            )}
                            {onGoToAbout && (
                                <button
                                    onClick={onGoToAbout}
                                    style={{
                                        background: 'transparent',
                                        color: '#333',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontSize: isMobile ? '14px' : '15px',
                                        textDecoration: 'underline',
                                        padding: isMobile ? '5px 8px' : '5px 10px',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    運営者について
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Voitter © 2025 */}
                    <div
                        style={{
                            width: '100%',
                            padding: isMobile ? '20px 0' : '30px 0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: isMobile ? '13px' : '14px',
                            color: '#666',
                        }}
                    >
                        Voitter © 2025
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeScreen;


